import { render, staticRenderFns } from "./StockListProducts.vue?vue&type=template&id=8d5c124a"
import script from "./StockListProducts.vue?vue&type=script&lang=js"
export * from "./StockListProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports